import React from 'react';
import PropTypes from 'prop-types';

import './layout.scss';

const LayoutContainer = (props) => {
  const { title, children } = props;

  return (
    <div className="row large-collapse layout">
      <div className="columns small-12 large-12 layout-container">
        <div id="title_netIncome_layout_test" className="layout-container__title">
          <h2>{title}</h2>
        </div>
        <div className="layout-container__body">
          {children}
        </div>
      </div>
    </div>
  );
};

LayoutContainer.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType(
    [
      PropTypes.node,
      PropTypes.func,
      PropTypes.string,
      PropTypes.array
    ]
  )
}

LayoutContainer.defaultProps = {
  title: '',
  children: []
}

export default LayoutContainer;
